import type { ReviewDraft } from './document';

export interface ResolvableItem {
  readonly kind: 'customer' | 'product';
  /** The document `field_path` this item resolves - `'/customer'` or
   * `'/lines/{line_key}/product'`, matching `ReferenceIssue.field_path`. */
  readonly fieldPath: string;
  readonly lineKey: string | null;
  readonly label: string;
}

/**
 * Every unresolved reference field in `draft`, in the order the redesigned review screen walks
 * through them: the customer first, then each row's concept top to bottom. This is what "N
 * cosas por resolver" counts and what "Resolver siguiente" steps through - one entry per field
 * that still needs an official Excel value (CLAUDE.md rule 4: unknown references block
 * delivery), matching `NoteDetail.open_reference_issues` in spirit without needing the
 * server's own issue ids to build the queue client-side.
 */
export function buildResolutionQueue(draft: ReviewDraft): readonly ResolvableItem[] {
  const items: ResolvableItem[] = [];
  if (draft.customer.officialName === null) {
    items.push({ kind: 'customer', fieldPath: '/customer', lineKey: null, label: 'Cliente' });
  }
  draft.lines.forEach((line, index) => {
    if (line.product.officialName === null) {
      items.push({
        kind: 'product',
        fieldPath: `/lines/${line.lineKey}/product`,
        lineKey: line.lineKey,
        label: `Concepto (fila ${String(index + 1)})`,
      });
    }
  });
  return items;
}
